import { useFormikContext } from 'formik';
import React, {InputHTMLAttributes, ReactElement} from 'react';

export interface SelectFieldProps extends InputHTMLAttributes<HTMLSelectElement> {
  name: string;
  label: string;
  isSubmitting?: boolean;
  sent?: boolean;
  mask?: (value: string) => string;
}

export const SelectField = ({ label, name, isSubmitting, sent, required = false, mask, ...props }: SelectFieldProps): ReactElement<HTMLDivElement> => {
  
  const {errors, touched, values, handleChange, handleBlur, setFieldValue} = useFormikContext<{[name:string]: string}>();

  return (
    <div className='form-field'>
      
      <label htmlFor={`input-${name}`}>
        <span>{label}:{ required ? ' *' : '' }</span>
        <select
          name={name}
          className="input-select" 
          id={`input-${name}`}
          // placeholder={label}
          value={values?.[name] || ''}
          onChange={handleChange as any}
          onBlur={handleBlur as any}
          disabled={isSubmitting || sent}
          {...props}
        >
          <option value="Solteiro(a)">Solteiro(a)</option>
          <option value="Casado(a)">Casado(a)</option>
          <option value="Separado(a)">Separado(a)</option>
          <option value="Divorciado(a)">Divorciado(a)</option>
          <option value="Viúvo(a)">Viúvo(a)</option>
        </select>
      </label>
      
      {!!errors?.[name] && !!touched?.[name] ? (
      <div className="form-error">{errors[name]}</div>
      ) : null}
    </div>
  );
}